import React from "react";
import WhyChoose from "../../common/WhyChoose";

const Why = ({ data }) => {

  // Access products_section from the data object
  const { why_choose_us } = data || {};

  // Safely destructure products array with default empty array
  const { heading_description = "", sub_heading = [] } = why_choose_us || {};

  return (
    <WhyChoose
      title="Why Choose Us"
      heading_description={heading_description}
      sub_heading={sub_heading}
    />
  );
};

export default Why;
